import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client'; // Nova API do React 18
import App from './App';
import { msalInstance } from './authConfig';
import './index.css';
import { createAppTheme } from './theme';

const theme = createAppTheme('light'); // Use the createAppTheme function to create the theme

const container = document.getElementById('root');
const root = createRoot(container); // Cria a raiz
root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </MsalProvider>
    </React.StrictMode>
);